import React, { useContext } from 'react'
import styles  from './ChatHeader.module.scss'
import MessageContext from '../../../../context/MessageContext';
import Avatar from '../../../../components/Avatar/Avatar';
import EyRnButton from '../../../../components/EyRnButton/EyRnButton';
import useWindowSize from 'hooks/useWindowSize';

interface ChatHeaderProps{
  closeHandler?: any;
}

export default function ChatHeader({closeHandler}: ChatHeaderProps) {
  const { chat } : any = useContext(MessageContext);
  const { isUltraWide } = useWindowSize(); 



  return (
    <header className={styles.header}>
      <div className={styles.headerTitle}>
        {isUltraWide && (
          <button
            onClick={() => closeHandler(false)}
            className="btn btn-flat text-white"
          >
            <i className="icon-arrow-left text-2x"></i>
          </button>
        )}
        <Avatar alt={chat.fullName} src={chat.picture} status={chat.status} />

        <div className={styles.headerTitleText}>
          <h3>{chat.fullName}</h3>
          <h5>{chat.userName}</h5>
        </div>
      </div>

      {/* Action button */}
      {!isUltraWide && (
        <div className={styles.actions}>
          <button className="btn-secondary">Meet (RTC)</button>
          <EyRnButton />
        </div>
      )}
    </header>
  );
}
